import { Typography } from "@mui/material"
import React from "react"
import { Colors } from "./style"
import { red } from "@mui/material/colors"
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleTwoToneIcon from '@mui/icons-material/CheckCircleTwoTone';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import CheckIcon from '@mui/icons-material/Check';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import PriorityHighRoundedIcon from '@mui/icons-material/PriorityHighRounded';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import BeenhereRoundedIcon from '@mui/icons-material/BeenhereRounded';
import InfoIcon from '@mui/icons-material/Info';

const StatsDiv = ({ title, number = 0, style, index = 0 }) => {

    return (
        <div style={{
            ...style,
            border: "1px solid " + Colors.white,
            borderRadius: "15px",
            padding: "2rem",
            paddingTop: "1rem !important",
            paddingBottom: "1rem !important",
            maxWidth: "26rem",
            height: "13rem",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            backdropFilter: "blur(10px)",  // Effetto glass
            background: "rgba(255, 255, 255, 0.1)",  // Trasparenza
            boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)'
        }}>

            <div style={{ width: "22rem", display: "flex", flexDirection: "column", justifyContent: "space-evenly", height: "100%" }}>

                <Typography variant="h5" color={Colors.white} style={{ fontWeight: "bold", width: "100%" }}>
                    {title}
                </Typography>



                <Typography variant="h2" color={Colors.white} style={{ fontWeight: "bold" }}>
                    {number}
                </Typography>

            </div>

            {/* <CheckCircleIcon style={{ color: Colors.successGreen, fontSize: "4rem" }} /> */}

            <div style={{
                // width: "8rem", height: "8rem",
                display: "flex", justifyContent: "center", alignItems: "center",
                borderRadius: "10rem",
                backgroundColor: index == 0 ? Colors.purple : index == 1 ? Colors.successGreen : Colors.orange,
                padding: "1rem"
            }}>

                {/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke={Colors.successGreen} class="size-2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                </svg> */}


                {
                    index == 0 ?
                        <PriorityHighRoundedIcon style={{ color: Colors.white, fontSize: "3rem" }} />

                        : index == 1 ?
                            <CheckRoundedIcon style={{ color: Colors.white, fontSize: "3rem" }} />
                            :
                            <InfoIcon style={{ color: Colors.white, fontSize: "3rem" }} />

                }


            </div>


        </div>
    )
}



export default StatsDiv